import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-mesh-brand))",
      d: "M6 20a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 3 17q0-1.25.875-2.125A2.9 2.9 0 0 1 6 14q1.25 0 2.125.875T9 17t-.875 2.125A2.9 2.9 0 0 1 6 20m12 0a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 15 17q0-1.25.875-2.125A2.9 2.9 0 0 1 18 14q1.25 0 2.125.875T21 17t-.875 2.125A2.9 2.9 0 0 1 18 20m-6-10a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 9 7q0-1.25.875-2.125A2.9 2.9 0 0 1 12 4q1.25 0 2.125.875T15 7t-.875 2.125A2.9 2.9 0 0 1 12 10"
    }, null, -1)
  ]))]))
}
export default { render: render }